import { z } from 'zod';
import { ProjectSettingsResponseSchema, ResolvedProjectContentSchema } from './Config.js';
export const ShareablePreviewResponseSchema = z
    .object({
    id: z.string(),
    projectId: z.string(),
    previewId: z.string(),
    isActive: z.boolean(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
})
    .strict();
export const ShareablePreviewWithProjectResponseSchema = z
    .object({
    preview: ShareablePreviewResponseSchema,
    project: z.object({
        id: z.string(),
        organizationId: z.string(),
        title: z.string(),
        description: z.string().nullable(),
        status: z.string(),
    }),
    content: ResolvedProjectContentSchema,
    settings: ProjectSettingsResponseSchema,
})
    .strict();
export const CreateShareablePreviewRequestSchema = z
    .object({
    previewId: z.string(),
})
    .strict();
//# sourceMappingURL=ShareablePreview.js.map